import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();

// Function to send custom welcome email
export const sendWelcomeEmail = async (userData) => {
  try {
    const sendWelcomeEmailFunction = httpsCallable(functions, 'sendWelcomeEmail');
    const result = await sendWelcomeEmailFunction({
      email: userData.email,
      displayName: userData.displayName || userData.name,
      role: userData.role || 'Candidate'
    });
    
    console.log('Welcome email sent:', result.data);
    return result.data;
  } catch (error) {
    console.error('Error sending welcome email:', error);
    throw error;
  }
};

// Function to send custom password reset email
export const sendCustomPasswordReset = async (email) => {
  try {
    const sendPasswordResetFunction = httpsCallable(functions, 'sendCustomPasswordReset');
    const result = await sendPasswordResetFunction({ email });
    
    console.log('Password reset email sent:', result.data);
    return result.data;
  } catch (error) {
    console.error('Error sending password reset email:', error);
    throw error;
  }
};

// Function to get email template settings
export const getEmailTemplateSettings = async () => {
  try {
    const getSettingsFunction = httpsCallable(functions, 'getEmailTemplateSettings');
    const result = await getSettingsFunction();
    
    console.log('Email template settings retrieved:', result.data);
    return result.data;
  } catch (error) {
    console.error('Error getting email template settings:', error);
    throw error;
  }
};

// Function to update email template settings
export const updateEmailTemplateSettings = async (settings) => {
  try {
    const updateSettingsFunction = httpsCallable(functions, 'updateEmailTemplateSettings');
    const result = await updateSettingsFunction(settings);
    
    console.log('Email template settings updated:', result.data);
    return result.data;
  } catch (error) {
    console.error('Error updating email template settings:', error);
    throw error;
  }
};

// Function to send submission link email
export const sendSubmissionLinkEmail = async (candidateData, submissionLink, year) => {
  try {
    const sendSubmissionLinkFunction = httpsCallable(functions, 'sendSubmissionLinkEmail');
    const result = await sendSubmissionLinkFunction({
      email: candidateData.email,
      firstName: candidateData.firstName,
      lastName: candidateData.lastName,
      submissionLink: submissionLink,
      year: year
    });
    
    console.log('Submission link email sent:', result.data);
    return result.data;
  } catch (error) {
    console.error('Error sending submission link email:', error);
    
    // Fallback: If Firebase Function is not deployed, show a helpful message
    if (error.code === 'functions/not-found' || error.message.includes('internal')) {
      const fallbackMessage = `Email functionality requires Firebase Functions deployment.
      
To enable email sending:
1. Run: firebase deploy --only functions
2. This will deploy the required email functions
3. Email functionality will then work immediately

For now, you can copy the submission link and send it manually:
${submissionLink}

Candidate: ${candidateData.firstName} ${candidateData.lastName}
Email: ${candidateData.email}`;
      
      // Create a more user-friendly error
      const fallbackError = new Error('Email functions not deployed yet');
      fallbackError.details = fallbackMessage;
      fallbackError.submissionLink = submissionLink;
      fallbackError.candidateData = candidateData;
      throw fallbackError;
    }
    
    throw error;
  }
};

// Function to get submission link email template settings
export const getSubmissionLinkTemplateSettings = async () => {
  try {
    const getSettingsFunction = httpsCallable(functions, 'getSubmissionLinkTemplateSettings');
    const result = await getSettingsFunction();
    
    console.log('Submission link template settings retrieved:', result.data);
    return result.data;
  } catch (error) {
    console.error('Error getting submission link template settings:', error);
    throw error;
  }
};

// Function to update submission link email template settings
export const updateSubmissionLinkTemplateSettings = async (settings) => {
  try {
    const updateSettingsFunction = httpsCallable(functions, 'updateSubmissionLinkTemplateSettings');
    const result = await updateSettingsFunction(settings);
    
    console.log('Submission link template settings updated:', result.data);
    return result.data;
  } catch (error) {
    console.error('Error updating submission link template settings:', error);
    throw error;
  }
};
